export default __webpack_public_path__ + "static/media/WishlistDemo.81365b49.svg";